import PostCard from "components/common/PostCard/PostCard";
import Navbar from "components/navbar/Navbar"; // ⬅️ navbar existente
import React, { useState } from "react";
import { changeFeedType } from "store/feed/feed.slice";
import { useAppDispatch, useAppSelector } from "store/hooks";
import SearchBarProfile from "views/OrganizationProfile/SearchBarProfile/SearchBarProfile";
import {
  ContentWrapper,
  LeftColumn,
  PageWrapper,
  RightColumn,
  Tab,
  Tabs,
} from "./Feed.styles";

import CreatePostModule from "components/common/CreatePostModule/CreatePostModule";
import FeedRightSidebar from "components/Feed/FeedRightSidebar/FeedRightSidebar";

const Feed: React.FC = () => {
  const [searchText, setSearchText] = useState("");
  const [filter, setFilter] = useState("mostRecent");
  const [refreshKey, setRefreshKey] = useState(0);
  const dispatch = useAppDispatch();
  const activeTab = useAppSelector((state) => state.feed.feedType);

  const handleTabChange = (tab: "following" | "me") => {
    dispatch(changeFeedType(tab));
  };
  return (
    <PageWrapper>
      <Navbar />
      <ContentWrapper>
        <LeftColumn>
          <CreatePostModule onPostCreated={() => setRefreshKey((k) => k + 1)} />
          {/* 
          <SearchBarProfile
            onSearch={setSearchText}
            onFilterChange={setFilter}
          /> */}
          <Tabs>
            <Tab
              active={activeTab === "following"}
              onClick={() => handleTabChange("following")}
            >
              News Feed
            </Tab>
            <Tab
              active={activeTab === "me"}
              onClick={() => handleTabChange("me")}
            >
              My Posts
            </Tab>
          </Tabs>
          <PostCard
            key={refreshKey}
            searchText={searchText}
            filter={filter}
          ></PostCard>
        </LeftColumn>

        <RightColumn>
          <FeedRightSidebar />
        </RightColumn>
      </ContentWrapper>
    </PageWrapper>
  );
};

export default Feed;
